import { render, staticRenderFns } from "./CollectionComplaintAttachment.vue?vue&type=template&id=5d9a2078&scoped=true"
import script from "./CollectionComplaintAttachment.vue?vue&type=script&lang=js"
export * from "./CollectionComplaintAttachment.vue?vue&type=script&lang=js"
import style0 from "./CollectionComplaintAttachment.vue?vue&type=style&index=0&id=5d9a2078&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a2078",
  null
  
)

export default component.exports